import instance from 'utils/axios/instance.axios';
import { SUMMARY_REPORT } from './_constant';

export const createSummaryReport = (body = {}) => instance.post(SUMMARY_REPORT.CREATE_REPORT, body);

export const submitSummaryReport = (body = {}) => instance.post(SUMMARY_REPORT.SUBMIT_REPORT, body);

export const updateSummaryReport = (body = {}) =>
  instance.patch(SUMMARY_REPORT.UPDATE_REPORT, body);
export const permissionUpdateSummaryReport = (body = {}) =>
  instance.patch(SUMMARY_REPORT.PERMISSION_UPDATE_REPORT, body);

export const uploadSummaryReportFile = (body = {}) =>
  instance.post(SUMMARY_REPORT.CREATE_REPORT_FILE, body);

export const getSummaryReport = (summaryReportId) =>
  instance.get(SUMMARY_REPORT.GET_SUMMARY_REPORT(summaryReportId));

export const getSummaryReportType = () => instance.get(SUMMARY_REPORT.GET_TYPE_SUMMARY_REPORT);

export const getSummaryReportExpenditureType = () =>
  instance.get(SUMMARY_REPORT.GET_EXPENDITURE_TYPE_SUMMARY_REPORT);

export const downloadFileReport = (data) =>
  instance.post(SUMMARY_REPORT.DOWNLOAD_REPORT_FILE, data, { responseType: 'blob' });

export const downloadReportPdfFile = (summaryReportId) =>
  instance.get(SUMMARY_REPORT.DOWNLOAD_REPORT_PDF_FILE, {
    params: { summaryReportId },
    responseType: 'blob',
  });

export const downloadReportDocxFile = (summaryReportId) =>
  instance.get(SUMMARY_REPORT.DOWNLOAD_REPORT_DOCX_FILE, {
    params: { summaryReportId },
    responseType: 'blob',
    headers: {
      Accept: 'application/json',
    },
  });

export const getSummaryReportReviews = (summaryReportId) =>
  instance.get(SUMMARY_REPORT.GET_SUMMARY_REPORT_REVIEWS(summaryReportId));

export const createSummaryReportReview = ({ summaryReportId, body = {} }) =>
  instance.post(SUMMARY_REPORT.CREATE_SUMMARY_REPORT_REVIEW(summaryReportId), body);

export const updateSummaryReportReview = ({ summaryReportId, reviewId, body = {} }) =>
  instance.patch(SUMMARY_REPORT.UPDATE_SUMMARY_REPORT_REVIEW(summaryReportId, reviewId), body);

export const downloadZipFile = (summaryReportId) => 
  instance.get(SUMMARY_REPORT.DOWNLOAD_ZIP(summaryReportId), {
    responseType: 'blob',
  });
